/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationPricingsSelfWorkerPricesQuery = gql`
  query GetSimulationPricingsSelfWorkerPricesQuery($guarantees: [GuaranteeInputType], $grantees: [GranteeInputType], $commission: CommissionInputType) {
    getSimulationPricingsSelfWorkerPrices_simulation_pricings_self_worker(guarantees: $guarantees, grantees: $grantees, commission: $commission) {
      guarantees {
 code  
level  
parentCode  
label  
legend  
selected  
editable  
recommended  
recommendedMessages  
value  
valueType  
unit  
base  
options  
ruleset  
monthlyPrice  
annualPrice  
RO  
healthInsurance  
labelsRO  
}
    }
  }
`;

export default GetSimulationPricingsSelfWorkerPricesQuery;
